import moment from "moment";
import {
  isOrionTelemetry,
  isOrionTelemetryDataAvailable,
  isOrionTelemetryLOS,
  isServiceSuccess,
  OrionTelemetryDatapoint,
  ServiceResult,
  UnitConverters,
} from "./data.types";

export function dpTimeToDate(dpTime: string): moment.Moment {
  const dpTimeData = ["year", "dayOfYear", "hour", "minute", "second"];
  let dpTimeSplit = dpTime.split(":").map((v) => parseFloat(v));
  let d = moment.utc();

  for (let i in dpTimeSplit) {
    d.set(dpTimeData[i] as any, dpTimeSplit[i]);
  }

  return d;
}

export function formatDataPoints(
  parameter: Array<[string, string]>,
  data: ServiceResult,
  converters?: UnitConverters,
): { [key: string]: string } {
  let rdata: { [key: string]: string } = {};
  parameter.forEach((p) => {
    rdata[p[1]] = "n/a";
  });

  if (
    isServiceSuccess(data) &&
    isOrionTelemetry(data.data) &&
    (isOrionTelemetryDataAvailable(data.data) || isOrionTelemetryLOS(data.data))
  ) {
    for (let p of parameter) {
      let dp: OrionTelemetryDatapoint | undefined = data.data.data?.find(
        (dp) => dp.name === p[0],
      );
      if (!dp) continue;
      if (typeof dp?.value === "number") {
        if (converters && dp.unit && dp.unit in converters) {
          rdata[p[1]] = converters[dp.unit](dp.value);
        } else if (dp.unit) {
          rdata[p[1]] = `${(dp.value as number).toFixed(1)}${
            dp.unit ? " " + dp.unit : ""
          }`;
        } else {
          rdata[p[1]] = "ERR";
        }
      } else if (dp?.value !== undefined) {
        rdata[p[1]] = dp?.value.toString() || "";
      }
    }
  }

  return rdata;
}
